import { useEffect } from 'react';
import { capitalizeFirstLetter } from '@la/utilities';
import { AccountInfoContext } from 'lib/apis/getAccountInfo';
import { ConsolidatedCheckoutProvider } from 'lib/context/ConsolidatedCheckoutContext/ConsolidatedCheckoutContext';
import { getSiteIdentityData } from 'redux/coreSlice';
import { useGetAccountInfoQuery } from 'redux/services/accountApi';
import { useGetUserIdQuery } from 'redux/services/userInfo';
import { useAppSelector } from 'redux/store';
import PageTitle from 'domains/Shell/PageTitle/PageTitle';
import Page from '../Shell/Page/Page';
import CheckoutPageContent from './CheckoutPageContent/CheckoutPageContent';
import ConfirmationPageContent from './ConfirmationPageContent/ConfirmationPageContent';

/* Checkout */
export default function ConsolidatedCheckout({
  pageName = 'checkout',
}: Readonly<{
  pageName: string;
}>) {
  const { siteId, siteName } = useAppSelector(getSiteIdentityData);
  const { data: userId } = useGetUserIdQuery(siteId);
  const { data: accountInfo } = useGetAccountInfoQuery(
    { context: AccountInfoContext.Member, siteId: siteId || '' },
    { skip: !siteId }
  );
  const user = accountInfo?.user;
  const userName = user ? `${user.firstName} ${user.lastName}` : undefined;

  const pageNameInTitleCase = capitalizeFirstLetter(pageName);

  useEffect(() => {
    document.title = siteName
      ? `${siteName}: ${pageNameInTitleCase}`
      : `${pageNameInTitleCase}`;
  }, [pageNameInTitleCase, siteName]);

  function getPageContent() {
    return pageName === 'checkout' ? (
      <Page id="checkout-page">
        <PageTitle>Checkout</PageTitle>
        <CheckoutPageContent
          siteId={siteId}
          userId={userId}
          userName={userName}
        />
      </Page>
    ) : (
      <Page id="confirmation-page">
        <PageTitle>Thank you</PageTitle>
        <ConfirmationPageContent siteId={siteId} />
      </Page>
    );
  }

  return (
    <ConsolidatedCheckoutProvider>
      {getPageContent()}
    </ConsolidatedCheckoutProvider>
  );
}
/* */
